import {
  AUTH_SYNDICATE_KEY,
  AUTH_TOKEN_KEY,
  AUTH_USER_KEY,
} from '../services/authStorage';

export async function clearAppCache(): Promise<void> {
  try {
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(r => r.unregister()));
    }
  } catch {
    // ignore
  }

  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map(k => caches.delete(k)));
    }
  } catch {
    // ignore
  }

  const authToken = localStorage.getItem(AUTH_TOKEN_KEY);
  const authUser = localStorage.getItem(AUTH_USER_KEY);
  const authSyndicate = localStorage.getItem(AUTH_SYNDICATE_KEY);

  try {
    sessionStorage.clear();
  } catch {
    // ignore
  }

  try {
    localStorage.clear();
    if (authToken) localStorage.setItem(AUTH_TOKEN_KEY, authToken);
    if (authUser) localStorage.setItem(AUTH_USER_KEY, authUser);
    if (authSyndicate) localStorage.setItem(AUTH_SYNDICATE_KEY, authSyndicate);
  } catch {
    // ignore
  }
}

export function hardReload(): void {
  const url = new URL(window.location.href);
  url.searchParams.set('_cb', String(Date.now()));
  window.location.replace(url.toString());
}
